/**
 * RTWO Native Currency Engine — Null Asset Adapter
 */

import type { CurrencyId } from '../domain-models';
import type { AssetAdapterStatus, IAssetAdapter } from './asset-adapter-interface';

export class NullAssetAdapter implements IAssetAdapter {
  readonly adapterId = 'null-asset-adapter';
  readonly adapterName = 'Null Asset Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): AssetAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async linkNativeCurrency(_currencyId: CurrencyId): Promise<boolean> {
    return false;
  }
}
